@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';

.payment-disclaimer {
  color: var(--default--text-color--6);
  padding-top: @space-16;
}
